import type { TranslationMessages } from '../types';

export const warehouses: TranslationMessages = {
  name: 'Warehouse |||| Warehouses',
  add: 'Add Warehouse',
  create: 'Create Warehouse',
  edit: 'Edit Warehouse',
  delete: {
    title: 'Delete Warehouse',
    description:
      'Are you sure you want to delete this warehouse? This action cannot be undone.',
  },
  list: 'Warehouse List',
  search: 'Search warehouses...',
  empty: 'No warehouses yet',
  form: {
    basicInfo: 'Basic Information',
    location: 'Location',
    name: 'Name',
    description: 'Description',
    address: 'Address',
    additionalAddressInfo: 'Additional Address Info',
    contact: 'Contact',
    latitude: 'Latitude',
    longitude: 'Longitude',
    createDescription: 'Create a new warehouse',
    editDescription: 'Update warehouse information',
    required: 'Please fill in all required fields',
    locationRequired: 'Please provide location coordinates',
    error: 'Failed to save warehouse',
  },
  fields: {
    address: 'Address',
    additionalAddressInfo: 'Additional Address Info',
    contact: 'Contact',
    description: 'Description',
    location: 'Location',
    name: 'Name',
    picture: 'Picture',
    lat: 'Latitude',
    lng: 'Longitude',
    pictures: "Warehouse's Pictures",
  },
  fieldGroups: {
    identity: 'Identity',
  },
  validation: {
    invalidLatitude: 'Invalid Latitude',
    invalidLongitude: 'Invalid Longitude',
  },
  };
